import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getPlayers = (data: PropertyType): Promise<PropertyType> => {
	return api.post(`players/list${data?.query}`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
};

export const getPlayersExport = (data: PropertyType): Promise<PropertyType> =>
	api.post(`export/players${data?.query}`, { sid: data.token }, setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
